import {KubernetesAlert} from "./KubernetesAlert";
import {MetricAlert} from "./MetricAlert";
import {LogAlert} from "./LogAlert";
import {TraceAlert} from "./TraceAlert";
import {KubernetesResourceAlert} from "./KubernetesResourceAlert";
import {MultiMetricAlert} from "./MultiMetricAlert";
import {AlertDestination} from "../../components/Alert/AlertDestination";

export enum AlertType {
    MultiMetric = "MultiMetric",
    Kubernetes = "Kubernetes",
    Log = "Log",
    Metric = "Metric",
    Trace = "Trace",
    KubernetesResource = "KubernetesResource"
}

export interface Alert {
    uuid: string,
    type: AlertType,
    name: string,
    description: string,
    alert: KubernetesAlert | MetricAlert | LogAlert | TraceAlert | KubernetesResourceAlert | MultiMetricAlert,
    destinations: AlertDestination[]
}

export enum ThresholdComparator {
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThanOrEqual = "LessThanOrEqual",
    LessThan = "LessThan",
}